import { type z } from 'zod';

export const getErrorList = (schema: z.ZodType<any>, data: any): string[] => {
  const result = schema.safeParse(data);
  if (result.success) {
    return [];
  }
  return result.error.issues.map((issue) => issue.message);
};
